(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moventrx-root-scalp-pdp"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.mrsReady === 'true') return;
    root.dataset.mrsReady = 'true';
    const mainMedia = root.querySelector('[data-main-media]');
    const hiddenVariant = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-button-label]');
    const selectedShade = root.querySelector('[data-selected-shade]');

    const setMainImage = (src, alt) => {
      if (!src || !mainMedia) return;
      let image = mainMedia.querySelector('.mrs-main-image');
      if (!image) {
        mainMedia.innerHTML = '';
        image = document.createElement('img');
        image.className = 'mrs-main-image';
        image.dataset.mainImage = '';
        mainMedia.appendChild(image);
      }

      // image_tag renders responsive srcset/sizes. Remove those before
      // swapping the source or the browser can keep showing the first image.
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.removeAttribute('loading');
      image.removeAttribute('fetchpriority');
      image.src = src;
      image.alt = alt || '';
    };

    const galleryThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    let galleryIndex = galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
    if (galleryIndex < 0) galleryIndex = 0;

    const showGalleryIndex = (index) => {
      if (!galleryThumbs.length) return;
      galleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      const thumb = galleryThumbs[galleryIndex];
      setMainImage(thumb.dataset.image, thumb.dataset.alt);
      galleryThumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    };

    galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showGalleryIndex(index));
    });

    root.querySelectorAll('[data-gallery-prev]').forEach((button) => {
      button.addEventListener('click', () => showGalleryIndex(galleryIndex - 1));
    });

    root.querySelectorAll('[data-gallery-next]').forEach((button) => {
      button.addEventListener('click', () => showGalleryIndex(galleryIndex + 1));
    });

    const selectVariant = (choice) => {
      if (!choice) return;
      if (hiddenVariant) hiddenVariant.value = choice.value;
      if (price) price.textContent = choice.dataset.price || '';
      if (mobilePrice) mobilePrice.textContent = choice.dataset.price || '';
      if (compare) {
        compare.textContent = choice.dataset.compare || '';
        compare.hidden = !choice.dataset.compare;
      }
      const available = choice.dataset.available === 'true';
      const configured = Number(choice.dataset.priceCents || 0) > 0;
      if (addButton) addButton.disabled = !available || !configured;
      if (addLabel) {
        addLabel.textContent = !configured ? root.dataset.setupLabel : available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      }
      root.querySelectorAll('.mrs-variant-card').forEach((card) => card.classList.remove('is-active'));
      const card = choice.closest('.mrs-variant-card');
      if (card) card.classList.add('is-active');
      if (selectedShade) selectedShade.textContent = choice.dataset.shadeName || '';
      setMainImage(choice.dataset.image, choice.dataset.alt);
    };

    root.querySelectorAll('[data-variant-choice]').forEach((choice) => {
      choice.addEventListener('change', () => selectVariant(choice));
    });
  };

  const initAll = (scope) => scope.querySelectorAll('[data-mrs-pdp]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
